import { BasicCommand } from "./BasicCommand";
/**
 * Created with IntelliJ IDEA.
 * User: aprzybyszewski
 * Date: 06.06.13
 * Time: 16:44
 * To change this template use File | Settings | File Templates.
 */


import { IdentityManagementConstants } from "../../constants/IdentityManagementConstants";
import { BasicController } from "../BasicController";
import { BasicSmartfoxConstants } from "../BasicSmartfoxConstants";
import { ShutDownControlTimer } from "../ShutDownControlTimer";
import { BasicLayoutManager } from "../../view/BasicLayoutManager";
import { CommonDialogNames } from "../../view/CommonDialogNames";
import { BasicStandardOkDialogProperties } from "../../view/dialogs/BasicStandardOkDialogProperties";
import { CommandController } from './../../../commanding/CommandController';
import { Localize } from "@goodgamestudios/localization";

export class CPSCommand extends BasicCommand {

    public _shutDownControlTimer: ShutDownControlTimer;

    protected get cmdId(): string {
        return BasicSmartfoxConstants.S2C_CHILD_PROTECTION_AUTO_SHUTDOWN_EVENT;
    }

    public executeCommand(error: number, params: any[]): boolean {
        switch (error) {
            case IdentityManagementConstants.ERROR_SHUT_DOWN_ALERT:
                this._shutDownControlTimer = new ShutDownControlTimer(IdentityManagementConstants.SHUTDOWN_CONTROL_TIMER);
                this._shutDownControlTimer.startCountDown();
                this.layoutManager.showDialog(CommonDialogNames.StandardOkDialog_NAME,
                    new BasicStandardOkDialogProperties(
                        Localize.text("generic_alert_warning"),
                        Localize.text("generic_alert_korea_logoutCountdown", [this._shutDownControlTimer.showTimerCountdown, Localize.text])));
                break;
            case IdentityManagementConstants.ERROR_UNDERAGE_LOGOUT:
                this.env.underAgeConnectionLost = true;
                this._shutDownControlTimer.stopShutDownTimer();
                CommandController.instance.executeCommand(BasicController.COMMAND_LOGOUT);
                break;
            default:

                break;
        }

        return super.executeCommand(error, params);
    }

    protected get layoutManager(): BasicLayoutManager {
        return BasicLayoutManager.getInstance();
    }
}

